var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircluePlusSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0E7490"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6603 11.9996C19.6603 12.4672 19.2662 12.8434 18.7764 12.8434H12.8835V18.4684C12.8835 18.9342 12.4876 19.3125 11.9996 19.3125C11.5116 19.3125 11.1157 18.936 11.1157 18.4684V12.8434H5.2228C4.73479 12.8434 4.33887 12.4658 4.33887 12C4.33887 11.5356 4.73479 11.1559 5.2228 11.1559H11.1157V5.5309C11.1157 5.06508 11.5116 4.6875 11.9996 4.6875C12.4876 4.6875 12.8835 5.06508 12.8835 5.5309V11.1559H18.7764C19.2662 11.1559 19.6603 11.5356 19.6603 11.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircluePlusSolid);
export default __webpack_public_path__ + "static/media/circlue-plus-solid.a51b44aa57f8749251c95d73ab84a697.svg";
export { ForwardRef as ReactComponent };